export default __webpack_public_path__ + "locales/cs/RoomLogoCover.json?hash=90c937247a6138ee54e5745e090fb33e";